import { ComponentStyleConfig } from "@chakra-ui/react";
import { fonts } from "../fonts";

export const buttonStyles: ComponentStyleConfig = {
	baseStyle: {
		borderRadius: '100px',
		fontFamily: fonts.heading
	},
}